export const examAdminQuestions = {
  pageTitle: "题库中心",
  pageSubtitle: "按题型使用可视化表单录入题目，系统自动生成题目编号和结构化数据。",
  createQuestion: "新建题目",
  createSuccess: "Question created",
  deleteSuccess: "Question deleted",
  searchPlaceholder: "Search by question code or stem",
  stemSummary: "Stem Summary",
  createTitlePrefix: "Create ",
  createFallbackTypeName: "Question",
  showArchived: "Show archived",
  hideArchived: "Hide archived",
  summaryArchivedVisible: "Archived visible: {value}",
  statusUpdated: "Question status updated",
  archivedSuccess: "Question archived",
  summaryTotal: "Total questions: {count}",
  summarySelected: "Selected questions: {count}",
  overview: {
    total: "Total Questions",
  },
  taskEditor: {
    createTitle: "Create Question",
    editTitle: "Edit Question",
    saveFirstToDebug: "Please save the question first, then use the debug workspace.",
    viewModeDebugHint:
      "You are in view mode. Click Edit in the top-right to use the debug workspace.",
    runExecStatus: "Execution",
    runCaseStatus: "Test Cases",
    runExecPass: "Run succeeded",
    runExecFail: "Run failed",
    candidateRunPass: "Passed",
    candidateRunFail: "Failed",
    unsavedLeaveConfirm: "You have unsaved changes. Leave this page?",
    tabs: {
      config: "Config",
      examView: "Candidate View",
      fullInfo: "Full Info",
      versionHistory: "Version History",
      debug: "Debug",
      versions: "Versions",
    },
  },
  messages: {
    selectDraftsToPublish: "Only draft questions can be published. Please reselect.",
    selectArchivableToArchive: "No archivable questions are currently selected",
    selectDraftsToDelete: "Only draft questions can be deleted. Please reselect.",
    batchPublished: "Published {count} questions",
    batchArchived: "Archived {count} questions",
    batchDeleted: "Deleted {count} draft questions",
  },
  batchSelection: {
    partialSelected:
      "Selected first {selected} items ({total} items match the current filters; the remainder is not selected)",
    allSelected: "Selected {count} items",
  },
  confirmArchiveSingle: {
    title: "Archive this question?",
    description: "Archived questions are hidden from the default list.",
  },
  confirmBatch: {
    publishDraftsTitle: "Publish the selected {count} draft questions?",
    archiveTitle: "Archive the selected {count} questions?",
    deleteDraftsTitle: "Delete the selected {count} draft questions?",
    deleteDraftsDescription: "This action cannot be undone.",
    archiveDescription: "Archived questions are hidden from the default list.",
  },
  batch: {
    publishDrafts: "Batch publish (drafts only)",
    archive: "Batch archive",
    deleteDrafts: "Batch delete (drafts only)",
    confirmDeleteDraftsDescription: "This action cannot be undone.",
    archiveAction: "Archive",
    confirmPublishDraftsTitle: "Publish the selected draft questions in batch?",
    confirmArchiveTitle: "Archive the selected questions in batch?",
    confirmDeleteDraftsTitle: "Delete the selected draft questions in batch?",
    publishAction: "Publish",
  },
  drawerTitleCreate: "新建题目",
  previewTitle: "题目预览（考生视角）",
  codeRulePrefix: "题目编号由系统在首次保存成功后自动生成，格式为",
  codeRulePattern: "Q-题型字母-年周-序号",
  codeRuleSuffix: "，生成后不可修改。",
  stats: {
    total: "总题数：{count}",
    published: "已发布：{count}",
    draft: "草稿：{count}",
    summaryUnavailable: "Question legend counts failed to load; legend counts are unavailable",
  },
  table: {
    code: "题目编号",
    title: "标题",
  },
  confirmDelete: {
    title: "确认删除这个题目吗？",
    description: "仅未被试卷或作答引用的题目允许删除。",
  },
  preview: {
    unnamedTitle: "未命名题目",
    emptyStem: "暂无题干",
    judgmentTrue: "正确",
    judgmentFalse: "错误",
    shortAnswerPlaceholder: "考生将在此输入简答内容",
    codePlaceholder: "考生将在此编写代码",
    publicCases: "示例 / 公开用例",
    noPublicCases: "暂无公开用例",
    caseTitle: "用例 {index}",
    input: "输入：",
    output: "输出：",
    explanation: "说明：",
    practicalDescription: "该题为实操题，考生进入后可创建环境并按要求完成操作。",
    accessHint: "访问说明：{value}",
    noAccessHint: "暂无",
    attackDefenseAttachmentDescription: "该题为附件类夺旗题，请下载附件后本地分析并提交 flag。",
    attachmentAssets: "附件资源：{value}",
    noAssets: "暂无",
    flagPlaceholder: "考生将在此输入 flag，例如 flag{...}",
  },
  editor: {
    sections: {
      choiceAnswer: "Options and Answer",
      referenceAnswerPoints: "Reference Answer and Scoring Points",
      judgeConfig: "Judge Config",
      environmentConfig: "Environment Config",
      attackDefenseConfig: "Attack Defense Config",
      aiMeta: "AI Metadata",
      structuredPreview: "Structured Preview",
    },
    labels: {
      taskTitle: "Question Name",
      taskDescription: "Question Description",
      correctAnswerMultiple: "Correct Answer (multiple allowed)",
      internalNote: "Internal Note (visible only to authors/admins)",
      tags: "Question Tags",
      knowledgePoints: "Knowledge Points",
      aiSource: "AI Source",
      aiGenerated: "AI Generated",
      effectivePorts: "Effective Ports",
      image: "Image ID",
      publicCase: "Sample/Public Case",
      hiddenCase: "Hidden Case",
    },
    objects: {
      choiceOption: "Option",
      keyword: "Keyword",
      scoringPoint: "Scoring Point",
      publicCase: "Public Case",
      hiddenCase: "Hidden Case",
      experienceEnvironment: "Experience Environment",
      temporaryEnvironment: "Temporary Environment",
    },
    actions: {
      aiFill: "AI Fill",
      manualAdd: "Add Manually",
      selectFromImageList: "Select from Image List",
      select: "Select",
      uploadAssetToLibrary: "Upload Attachment to Asset Library",
    },
    messages: {
      required: "Required",
      selectQuestionType: "Select a question type",
      inputTitle: "Enter a question title",
      inputStem: "Enter the question stem",
      inputOptionText: "Enter option text",
      selectCorrectAnswer: "Select the correct answer",
      selectAtLeastOneLanguage: "Select at least one language",
      inputCaseInput: "Enter sample input",
      inputCaseOutput: "Enter expected output",
      selectImage: "Select an image ID",
      selectContainerPort: "Select a container port",
      inputStandardFlag: "Enter the standard flag",
      requireInitScriptForDynamicFlag: "Initialization script is required in dynamic flag mode",
      selectAtLeastOneAttachment: "Select at least one attachment",
      uploadAssetSuccess: "Attachment uploaded: {filename}",
      uploadAssetFailed: "Attachment upload failed",
      noUsableAnalysis: "AI did not return usable analysis. Try again later or fill it manually.",
      analysisFilled: "AI filled the analysis",
      analysisFailed: "AI analysis generation failed",
      noUsableTags: "AI did not return usable tags. Try again later or fill them manually.",
      tagsFilled: "AI filled the tags",
      tagsFailed: "AI tag generation failed",
      noUsableKnowledgePoints:
        "AI did not return usable knowledge points. Try again later or fill them manually.",
      knowledgePointsFilled: "AI filled the knowledge points",
      knowledgePointsFailed: "AI knowledge point generation failed",
    },
    placeholders: {
      title: "Enter the question title",
      stem: "Enter the stem, background, or operation requirements",
      referenceAnswer: "Enter the reference answer or scoring guidance",
      keywordExample: "e.g. SQL injection, parameterized query",
      pointExample: "e.g. Identify the risk and provide a fix",
      languageExample: "e.g. python, java, cpp",
      starterCode: "Enter default starter code",
      codeCaseInputExample:
        "e.g. 3 5 (two arguments separated by spaces; line breaks are also supported)",
      codeCaseOutputExample: "e.g. 8",
      executionHintExample: "e.g. Use stdin/stdout. Network access is prohibited.",
      image: "Select an image ID",
      containerPort: "Select a container port",
      imageKeyword: "Filter by image name or image ID",
      attachment: "Select an attachment",
      analysis: "Enter analysis, notes, or reference thinking",
      internalNote: "Internal note; not shown to exam candidates",
      tagsExample: "e.g. security, database, container",
      knowledgePointsExample: "e.g. SQL injection, firewall policy",
      aiSource: "e.g. AI Task #123 (Bailian) / manual revision",
    },
    hints: {
      imageListEmpty: "Pull available images in Image Management first.",
      imageListManaged:
        "The image list comes from Image Management. Only maintained image IDs can be selected.",
      imageListManagedShort: "The image list comes from Image Management (select by image ID).",
      imagesLoading: "Loading images",
      noImagesAvailable: "No available images. Pull images in Image Management first.",
      imagePicker:
        "Filter by image name or image ID in the dialog, then write the selected image ID back to the field.",
      noDeclaredPortWithGovernance:
        "The current image does not declare any ports. Choose another image or add EXPOSE in image governance first.",
      noDeclaredPort:
        "The current image does not declare any ports. Choose another image or add EXPOSE.",
      practicalInitScript:
        "Script note: the platform runs scripts inside the container with `sh -s`; `/workspace` is recommended, and scripts should be repeatable (idempotent).",
      callbackMode:
        "Callback mode does not need a platform-side check script. The program inside the image should report completion back to the platform.",
      practicalCheckScript:
        "Check script contract: exit code `0` means pass; non-zero means fail. Prefer explicit error output to stderr on failure.",
      hiddenCasesForJudge:
        "Hidden cases are used for final judging and are not shown to candidates.",
      dynamicFlagContainerOnly:
        "Dynamic flags depend on environment instance creation and injection; the carrier is fixed to container mode.",
      attackInitScript:
        "Contract: the startup flow should be baked into the image. The initialization script is for per-question instance preparation and is required in dynamic flag mode.",
      assetSource: "Attachments come from the asset module and can be selected in batches.",
      attachmentMode:
        "Attachment mode is for static analysis questions. Uploaded assets can be selected directly from the dropdown.",
      dynamicFlagValidation:
        "Dynamic flags are generated and injected into container environment variables when an environment instance is created. The platform stores only a hash for validation.",
      aiSourceExtra:
        "Record the AI task or manual revision source, such as AI Task #123 (Bailian) or manual revision.",
      structuredPreview:
        "This page is form-first. The system generates structured JSON automatically, and the preview below is only for checking the final persisted content.",
      practicalEditor:
        "Use this to edit and verify initialization and check scripts together. After an environment is created, the initialization script runs once automatically.",
    },
    enums: {
      environmentType: {
        virtualMachine: "Virtual Machine",
      },
      checkMode: {
        exec: "External container exec check",
        callback: "In-container callback report",
      },
    },
    switches: {
      aiGenerated: "AI Generated",
      manualCreated: "Manually Created",
    },
    scripts: {
      practicalCheckExample:
        '#!/bin/sh\nset -eu\n\n# Check that the key file exists\ntest -f /workspace/app/answer.txt\n\n# Check that the file content matches the expected value\nexpected="hello-exam"\nactual="$(cat /workspace/app/answer.txt)"\n[ "$actual" = "$expected" ]',
      attackInitExample:
        '#!/bin/sh\nset -eu\n\n# The image ENTRYPOINT/CMD owns startup; this script only prepares the question instance.\n# Example: write the dynamic flag to the location your app reads (adjust for your image structure)\nmkdir -p /workspace\necho "$EXAM_DYNAMIC_FLAG" > /workspace/flag.txt',
    },
    ai: {
      sourceFormat: "AI Task #{taskId} ({mode})",
      modes: {
        bailian: "Bailian",
        placeholder: "Rule Generation",
        placeholderFallback: "Rule Completion",
        local: "Local Generation",
      },
    },
  },
} as const;
